
import Vue from 'vue'
export default Vue.extend({
  data: function() {
    return {
      observer: null as IntersectionObserver | null,
    }
  },

  mounted() {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(({ isIntersecting }) => {
          if (isIntersecting) {
            this.$emit('view')
            observer.unobserve(this.$el)
          }
        })
      },
      { threshold: 1 }
    )
    this.observer.observe(this.$el)
  },
  beforeDestroy() {
    this.observer!.disconnect()
  },
})
